import Vue from 'vue'
import App from './App.vue'
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.min.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(BootstrapVue) // Install BootstrapVue
Vue.use(IconsPlugin)  // Optionally install the BootstrapVue icon components plugin

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
